/* eslint-disable */
import {fetchExcelAcceso, fetchExcelusuarios } from 'services/ReporteRol.service';
import { showAlert } from './alert.actions';

export const downloadExcelAccesosRol = (fechaInicio, fechaFin) => async (dispatch) => {
  try {

    const params = {
      fechaInicio: fechaInicio && fechaInicio !== undefined && fechaInicio!== null && fechaInicio !== '' ? fechaInicio : null,
      fechaFinal: fechaFin && fechaFin!== undefined && fechaFin !== null && fechaFin !== '' ? fechaFin : null
    };

    const response = await fetchExcelAcceso(params);

    return { success: true, response };
  } catch (error) {
     dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};


export const downloadExcelUsuariosRol = (fechaInicio, fechaFin) => async (dispatch) => {
  try {

    const params = {
      fechaInicio: fechaInicio && fechaInicio !== undefined && fechaInicio!== null && fechaInicio !== '' ? fechaInicio : null,
      fechaFinal: fechaFin && fechaFin!== undefined && fechaFin !== null && fechaFin !== '' ? fechaFin : null
    };

    const response = await fetchExcelusuarios(params);

    return { success: true, response };
  } catch (error) {
     dispatch(showAlert('Error al descargar el documento', 'error'));
    return { success: false, response: error };
  }
};